import reframe from 'nike-re-framejs';
import { defaultMiddlewares } from '@/common/util';
import Immutable from 'immutable';
import { getLocale } from '@/common/oldMobile';
import moment from 'moment';
import n1Client from '@/_http/axiosN1Client';

reframe.regEventDb('event::liveStreams.load', defaultMiddlewares, db => {
    if (!db.hasIn(['liveStreams', 'matches'])) {
        fetchLiveStreams();
    }
    return db;
});

function fetchLiveStreams() {
    n1Client
        .get('/v1/stream/match-data', { headers: { 'Content-Language': getLocale() } })
        .then(data => {
            reframe.dispatch(['event::liveStreams.load.success', data]);
        })
        .catch(error => {
            reframe.dispatch(['event::liveStreams.load.failed', error]);
        });
}

reframe.regEventDb('event::liveStreams.load.success', defaultMiddlewares, (db, [data]) => {
    const nextHour = moment()
        .add(1, 'hours')
        .toDate();
    const liveStreams = data.reduce((acc, item) => {
        //iba zapasy kt. zacnu do hodiny
        if (moment(item.match.startTime) < nextHour) {
            acc[item.match.id] = item;
        }
        return acc;
    }, {});
    return db.setIn(['liveStreams', 'matches'], Immutable.fromJS(liveStreams));
});

reframe.regEventDb('event::liveStreams.load.failed', defaultMiddlewares, db => {
    return db.setIn(['liveStreams', 'matches'], Immutable.fromJS({}));
});

reframe.regEventDb('event::liveStreams.clear', defaultMiddlewares, db => {
    return db.deleteIn(['liveStreams', 'matches']);
});
